import { createFileRoute } from '@tanstack/react-router'
import { PolicyRedraftPage } from '@/features/policy-detail/redraft-page'
import { requireActiveSubscription } from '@/lib/middleware'

// Generated path: `/compliance/policies/$policyId/redraft/$proposalId`. BOTH trailing underscores
// matter. `policies_` keeps this out of the policies LIST page, as `policies_.$policyId.tsx` does.
// `$policyId_` keeps it out of the POLICY DETAIL page: without it TanStack nests this under that
// route, and since `PolicyDetailPage` renders no <Outlet/>, the URL loads and silently shows the
// policy page instead — verified in the browser, which is the only place that failure is visible.
//
// Phase 2g, ask 4: the redraft review moves out of its dialog. A real route means the document gets
// the whole window, the review is linkable (an owner can send "here is what the AI proposed" to a
// colleague), and the browser Back button behaves.
export const Route = createFileRoute('/_authenticated/_organization/compliance/policies_/$policyId_/redraft/$proposalId')({
  beforeLoad: async () => requireActiveSubscription(),
  component: PolicyRedraftPage,
})
